import { defineComponent as _defineComponent } from 'vue'
import XIcon from '@/assets/img/XIcon.svg'
import { ref } from '@nuxtjs/composition-api'


export default /*#__PURE__*/_defineComponent({
  __name: 'SuggestionInput',
  props: {
    value: null,
    pills: null,
    suggestions: null
  },
  emits: ["input", "focus", "blur", "suggestion-selected", "pill-selected"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: string): void
  (e: 'focus'): void
  (e: 'blur'): void

  (e: 'suggestion-selected', item: any): void
  (e: 'pill-selected', value: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: string
  pills?: any[]
  suggestions?: Array<any & { selectable?: boolean }>
};





const searchInput = ref<HTMLElement>()

function selectSuggestion(item: unknown) {
  emit('suggestion-selected', item)
  searchInput.value!.focus()
}

// TODO up down arrows
function onKeyDown(event: KeyboardEvent) {
  if (event.key === 'Enter') {
    if (props.suggestions != null && props.suggestions?.length > 0) {
      selectSuggestion(props.suggestions[0])
      event.stopPropagation()
    }
  }
}

function onBlur(event: FocusEvent) {
  // don't emit blur if the user clicked on a suggestions
  if (event.relatedTarget == null) {
    emit('blur')
  }
}

return { __sfc: true,props, emit, searchInput, selectSuggestion, onKeyDown, onBlur, XIcon }
}

})